module.exports = __webpack_public_path__ + "static/media/catalouge-02.903d7b7a.jpg";